import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Store } from '@ngxs/store';
import { UsersState } from '../states/users/users.state';
import { catchError, map, Observable, of } from 'rxjs';
import { SetLoggedInUser } from '../states/users/user.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthguardService {
  constructor(
    public authenticationService: AuthenticationService,
    public router: Router,
    private store: Store
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    const isAuthenticated = this.authenticationService.isAuthenticated();
    const loggedInUser = this.store.selectSnapshot(UsersState.loggedInUser);

    if (!isAuthenticated) {
      return this.router.createUrlTree(['/logga-in']);
    }

    if (loggedInUser) {
      return this.resolveRouteAccess(next);
    }

    return this.store.dispatch(new SetLoggedInUser()).pipe(
      map(() => this.resolveRouteAccess(next)),
      catchError((error) => {
        console.error(
          'AuthguardService: Error validating logged in user: ',
          error
        );
        this.authenticationService.logout(false);
        return of(this.router.createUrlTree(['/logga-in']));
      })
    );
  }

  private resolveRouteAccess(next: ActivatedRouteSnapshot): boolean | UrlTree {
    const isAuthenticated = this.authenticationService.isAuthenticated();

    /* If path is partnerportal and user is of role partner */
    if (next.routeConfig?.path === 'partnerportalen' && isAuthenticated) {
      if (this.isPartnerOrAdmin()) return true;
      else return false;
    } else if (next.routeConfig?.path !== '/logga-in' && isAuthenticated) {
      if (this.store.selectSnapshot(UsersState.driverMode) && !this.isDriverRoute(next.routeConfig?.path)) {
        return this.router.createUrlTree(['/hem']);
      }
      /* If path is not partnerportal and not logga-in, navigate to  */
      if (this.isPartner()) {
        this.router.navigate([`/partnerportalen`]);
        return false;
      }
    }

    if (isAuthenticated) {
      return true;
    } else {
      return this.router.createUrlTree(['/logga-in']);
    }
  }

  private isDriverRoute(path: string | undefined): boolean {
    return [
      'hem',
      'ny-bokning',
      'bokning',
      'bokning/:id',
      'redigera-bokning/:id',
      'hantera-betalning',
    ].includes(path || '');
  }

  isPartner(): boolean {
    const loggedInUser = this.store.selectSnapshot(UsersState.loggedInUser);

    return (
      loggedInUser?.roles?.some((role) => role.name === 'ROLE_PARTNER') || false
    );
  }

  isPartnerOrAdmin(): boolean {
    const loggedInUser = this.store.selectSnapshot(UsersState.loggedInUser);

    return (
      loggedInUser?.roles?.some(
        (role) => role.name === 'ROLE_PARTNER' || role.name === 'ROLE_ADMIN'
      ) || false
    );
  }
}
